import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PrimitiveAtom } from "jotai";
import { omniAtom } from "src/utils/atoms";

import { BasePogWithId } from "./types";

const prefix = "merchflow";

export const selectBasePogIndexAtom = omniAtom({
  prefix,
  key: "selectBasePogIndex",
  value: 0,
});

export const basePogTemplateAtoms = omniAtom({
  prefix,
  key: "templateBasePogs",
  value: [] as BasePogWithId[],
});

export const pogTemplateAtoms = omniAtom({
  prefix,
  key: "POGTemplate",
  value: [] as PrimitiveAtom<Pog>[],
});

export const selectedTemplateAtom = omniAtom({
  prefix,
  key: "selectedTemplate",
  value: "",
});
